import React, { useEffect } from "react";
import { LoginSection } from "./LoginSection.js";
import { JoinSection } from "./JoinSection.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import Signup from "../Signup/Signup.js";

import "./Login.scss";

const Login = (props) => {
  const { mobileCondition } = useMediaQueries();
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const {
    submitCallback,
    callback,
    inviteDomainName,
    addSubUserToOrganization, // this is a call for add sub to organization by link invite
    completeAddSubUser, // this is a call for add sub to organization by email invite
    email,
    AuthenticationOptions,
    enforceStrongPass,
  } = props;

  const handleClick = () => {
    setModal({
      modal: Signup,
      modalSize: "full-modal",
      props: {
        enforceStrongPass,
        inviteDomainName,
        addSubUserToOrganization,
        completeAddSubUser,
        AuthenticationOptions,
      },
    });
  };

  useEffect(() => {
    if (callback)
      return () => {
        callback();
      };
  }, []);

  return (
    <div className="login-modal">
      <div className="top-section">
        <LoginSection
          callback={
            submitCallback ? submitCallback : callback ? callback : null
          }
          email={email}
          addSubUserToOrganization={addSubUserToOrganization}
          completeAddSubUser={completeAddSubUser}
        />
        <div className="modal-vertical-divider"></div>
        {mobileCondition ? (
          <div className="join-link" onClick={handleClick}>
            <span>{getTextByKey("login-not-a-member")}</span>{" "}
            <span className="link">{getTextByKey("click-here")}</span>
          </div>
        ) : (
          <JoinSection
            inviteDomainName={inviteDomainName}
            completeAddSubUser={completeAddSubUser}
            AuthenticationOptions={AuthenticationOptions}
            enforceStrongPass={enforceStrongPass}
          />
        )}
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default Login;
